import { t } from 'i18next';
import React from 'react'
import Modal from 'react-modal';
import ViewTextGenericIndicators from '../generic-component/ViewTextGenericIndicators';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90%', // Más responsivo
    maxWidth: '600px',
    maxHeight: '90vh',
    overflowY: 'auto',
    padding: '30px',
    borderRadius: '12px'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1000
  }
};

Modal.setAppElement('#root');
const L5ModalAlternative = ({ modalIsOpen, closeModal, data, moduleSelected }) => {

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Previsualizar Tecnología"
      >

        <form>
          <div style={{ height: "600px", width: "500px" }}>
            <div className="row">
              <span className="text-center" style={{ fontWeight: 'bold', fontSize: '1.2em', paddingBottom: '0.3em' }}>{t('general.title-modal-alternative')} </span>
              <div className="col-md-12">
                <label className="form-label label-information text-justify">
                  {t("alternative.short.code")}:
                </label>
                <label className="form-label text-justify font-weight-bold">
                  {data.code}
                </label>
              </div>
              <div className="col-md-12">
                <label className="form-label label-information text-justify">
                  {t("alternative.short.name")}:
                </label>
                <label className="form-label text-justify font-weight-bold">
                  {data.name}
                </label>
              </div>
              <div className="col-md-12">
                <label className="form-label label-information text-justify">
                  {t("alternative.short.purpose")}:
                </label>
                <label className="form-label text-justify">
                  {data.purpose}
                </label>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-12">
                <ViewTextGenericIndicators 
                  values={data} 
                  occupation={12} 
                  moduleKey={moduleSelected?.key}
                  tooltipPlace="right" //"top", "bottom", "right"
              />
              </div>
            </div>

          </div>

        </form>
      </Modal>
    </div>
  )
}

export default L5ModalAlternative